import React from 'react';

import { RichText } from '@/components/rich-text';
import { Text } from '@/components/text';

import type { Maybe } from '@/app/generated/graphql';
import type { TextVariants } from '@/components/text';
import type { TextLayoutBody } from '@/components/text-layout';
import type { Document } from '@contentful/rich-text-types';

type BodyProps = {
  body?: Maybe<TextLayoutBody> | string;
  bodyVariant?: TextVariants['variant'];
};

export const Body = ({ body, bodyVariant }: BodyProps) => {
  if (!body) {
    return null;
  }

  return typeof body === 'string' ? (
    <div>
      <Text variant={bodyVariant}>{body}</Text>
    </div>
  ) : (
    <div>
      <RichText
        links={body.links}
        document={body.json as Document}
        bodyVariant={bodyVariant}
      />
    </div>
  );
};
